const projectStatus = {
    OPEN: 0,
    CLOSE:1
}

export default projectStatus;